// I ruoli in ordine gerarchico decrescente: admin > fleet_manager > user.
export const USER_ROLES = ['admin', 'fleet_manager', 'user'];
export const USER_LANGUAGES = ['it', 'en'];
export const USER_THEMES = ['light', 'dark'];
// Il minimo del modello, valido per ogni password.
export const USER_PASSWORD_MIN_LENGTH = 6;
// La regex storica dell'endpoint. `z.email()` e' piu' stretta e rifiuterebbe
// indirizzi legittimi (`%`, `&`, `'` nella parte locale, domini non ASCII).
export const USER_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//# sourceMappingURL=user.js.map